<script lang="ts">
  import { Text, Icon } from "@getprovi/craft-svelte";
  import { InfoCircleSolid } from "@getprovi/craft-svelte-icons";
</script>

<div
  class="craft rounded-sm fizz-card fizz-inset-square-16 fizz-surface-gray"
  data-testId="requested-item-banner"
>
  <div class="flex gap-4 fizz-stack-4">
    <Icon iconName={InfoCircleSolid} color="neutral" size="icon-sm" />
    <Text as="span" color="neutral" uppercase>About requests</Text>
  </div>
  <Text as="p" size="xs"
    >Check your email for updates on whether your request has been fulfilled, and any changes to
    your order total.</Text
  >
</div>
